import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
// import Helmet from 'react-helmet'
import { Helmet } from 'react-helmet-async'
import { useLocation } from 'react-router'

import * as R from 'ramda'
import { canonicalComputer } from './utils'

// Parsing and formatting header tag json for Helmet
export const computeHeaderTags = (headerTags, pagination) => {
  const tags = {}
  const links = []
  const scripts = []
  const metaTags = []
  try {
    const jsonTags = JSON.parse(headerTags)
    jsonTags.forEach(item => {
      if(item.tag === 'title') {
        tags.title = item.content.replace(/\u00c3\u0089/g, 'É')
      } else if(item.tag === 'meta') {
        const nullRemoved = R.reject(R.isNil, item)
        const tagRemoved = R.omit('tag', nullRemoved)
        metaTags.push(tagRemoved)
      } else if(item.tag === 'link') {
        // to fix the paginated canonical meta tag and add pre next urls
        if(pagination && item.rel === 'canonical') {
          const canonicalItems = canonicalComputer(item, pagination)
          links.push(...canonicalItems)
        } else {
          links.push(item)
        }
      } else if(item.tag === 'script') {
        if(Array.isArray(item.content)) {
          item.content.forEach(elm => scripts.push({ ...item, content: elm }))
        } else {
          scripts.push(item)
        }
      }
    })
    tags.meta_tags = metaTags
    tags.links = links
    tags.scripts = scripts
  } catch(e) {
    return null
  }
  return tags
}

const AppHelmet = ({ headerTagsJson, fallback, pagination }) => {
  // shouldComponentUpdate(nextProps) {
  //   return (
  //     this.props.headerTagsJson !== nextProps.headerTagsJson ||
  //     this.props.fallback !== nextProps.fallback
  //   )
  // }
  const location = useLocation()


  if(!headerTagsJson && !fallback) return null
  if(headerTagsJson) {
    const headerTags = useMemo(
      () => computeHeaderTags(headerTagsJson, pagination),
      [location?.pathname, pagination?.currentPage],
    )
    // if error occurred in computeHeaderTags, headerTags can be empty
    if(!headerTags) return ''
    const scripts = headerTags.scripts.map((script, index) => {
      const key = 'script' + index
      let content = ''

      try {
        content = JSON.stringify(script.content)
      } catch(e) {} // eslint-disable-line
      return (
        <script key={key} type={script.type} data-react-helmet="true">
          {content}
        </script>
      )
    })

    return (
      <Helmet
        title={headerTags.title}
        meta={headerTags.meta_tags}
        link={headerTags.links}
      >
        {scripts}
      </Helmet>
    )
  }
  return (
    <Helmet
      title={fallback.title}
      meta={fallback.meta_tags}
    />
  )
}

AppHelmet.propTypes = {
  // JSON format
  headerTagsJson: PropTypes.string,
  fallback: PropTypes.shape({
    title: PropTypes.string,
    meta_tags: PropTypes.arrayOf(PropTypes.shape({})),
  }),
  pagination: PropTypes.shape({
    currentPage: PropTypes.number,
  }),
}


export default AppHelmet
